module.exports = __webpack_public_path__ + "img/Illustration.717764c1.png";